<script setup lang="ts">
    import type { AlgoliaProduct } from '@nuxtjs/algolia';

    interface SearchResultProductsProps {
        items: AlgoliaProductHit;
    }
    defineProps<SearchResultProductsProps>();

    /**
     * This transformation is needed, because only ProductPreview is expected to contain a URL.
     * see: utils/product.ts > processApiProduct() > getCMSProductBaseInfo()
     */
    const transformItemToProductPreview = (item: AlgoliaProduct) => {
        const content: ProductPreviewContent = {
            id: item.id,
            url: item.url,
            title: item.title,
            types: item.types,
            weight: item.weight,
            wheels: item.wheels,
            features: item.features,
            max_age: item.max_age,
            min_age: item.min_age,
            max_height: item.max_height,
            min_height: item.min_height,
        };

        const reviews =
            item.reviews_average && item.reviews_count
                ? {
                      averageRating: item.reviews_average,
                      reviewCount: item.reviews_count,
                  }
                : undefined;
        const showReviewsFlag = showReviews(item.product_category);

        return Object.assign(item, { content, reviews, showReviews: showReviewsFlag }) as ProductPreviewFieldsFragment;
    };
</script>
<template>
    <atm-grid
        class="mol-search-result-products"
        tag="ul">
        <li
            v-for="item in items"
            :key="item.objectID"
            :data-insights-object-id="item.objectID"
            :data-insights-position="item.__position"
            :data-insights-query-id="item.__queryID"
            class="col-span-2 md:col-span-12 lg:col-span-6 xl:col-span-4">
            <mol-product-tile
                :product="transformItemToProductPreview(item)"
                sort-colors-by-refinement />
        </li>
    </atm-grid>
</template>
